import { render, staticRenderFns } from "./cardcase.vue?vue&type=template&id=8b87e9f0&scoped=true&"
import script from "./cardcase.vue?vue&type=script&lang=js&"
export * from "./cardcase.vue?vue&type=script&lang=js&"
import style0 from "./cardcase.vue?vue&type=style&index=0&id=8b87e9f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b87e9f0",
  null
  
)

export default component.exports